import axios from "../../helpers/axios/axios";
import { BASE_URL } from "../../helpers/common/config";
import { errorHandler } from "../../helpers/common/utility";
import { setLoading } from "./app";

export const postReview = ({ rkun_id, ps_id, comment, rating }, succ) => {
  const url = BASE_URL + "/api/internal/kritik-saran";
  return (dispatch, state) => {
    dispatch(setLoading(true));
    return axios
      .post(url, {
        rating,
        comment,
        rkun_id,
        ps_id,
      })
      .then((payload) => {
        return succ && succ();
      })
      .catch((err) => {})
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
};

export const checkReview = ({ rkun_id, ps_id }, fail) => {
  const url = BASE_URL + "/api/internal/kritik-saran";
  return (dispatch, state) => {
    dispatch(setLoading(true));
    return axios
      .get(url, {
        params: {
          rkun_id,
          ps_id,
        },
      })
      .then((payload) => {})
      .catch((err) => {
        if (err.response && err.response.status == 404) {
          return fail && fail();
        }
        return errorHandler(dispatch, err);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
};
